module.exports = __webpack_public_path__ + "imgs/cart.ef6c6f0f2caa3db67c8819a81a3db8c7.svg";